import {apiGet, apiPost, apiPut, apiDelete, apiPatch} from '@/utils/request'

/**
 * 获取网页微信分享签名
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1147
 * @return Promise
 *
 * @author vince
 */
export function getWechatSDKSign() {
  return apiGet('/system/wechat_sdk_sign')
}

/**
 * 获取oss上传签名
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1183
 * 
 * @return Promise
 * 
 * @author vince
 */
export function getOssSign() {
  return apiGet('/system/oss_sign')
}

/**
 * 获取sts上传签名
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1313
 * 
 * @return Promise
 * 
 * @author vince
 */
export function getStsSign() {
  return apiGet('/system/sts')
}

/**
 * 加载页面初始化数据
 * 
 * @return Promise
 * @author vince
 */
export function getInitialData() {
  return apiGet('/system/base_data')
}

/**
 * 绑定手机接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1181
 * 
 * @param  {string} mobile [手机号码]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function sendMobileCode(mobile) {
  return apiGet('/system/mobile_code', {mobile})
}

/**
 * 获取oss信息接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1183
 * 
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function getOSSInfo() {
  return apiGet('/system/oss_sign')
}

/**
 * 微信公众号jssdk签名接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1225
 * 
 * @param  {string} url [手机号码]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function getWechatJSSign(url) {
  return apiGet('/system/wechat_jssdk', {url})
}

/**
 * 提交反馈建议
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1225
 *
 * @param  {string} content [反馈内容]
 * @param  {string} url     [页面地址]
 * @param  {string} url     [页面标题]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author vincent.row <vincenrow@qq.com>
 */
export function submitFeedback(content, page_url, page_title) {
  return apiPost('/system/feedback', {content, page_url, page_title})
}

/**
 * 获取用户评论消息接受地址
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1578
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function getCommentInfo(id) {
  return apiGet('/message/comment/:id/view', {id})
}

/**
 * 刷新CDN文件缓存
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/1225
 *
 * @param  {string} object_path [资源url]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function refreshCDNFile(object_path) {
  return apiPost('/system/cdn_clear', {object_path})
}

/**
 * 上传事件统计
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/2323
 *
 * @param  {string} type [类型]
 * @param  {string} url [当前链接]
 * @param  {string} title [网页标题]
 * @param  {string} event_key [事件类型]
 * @param  {string} event_value [事件操作]
 * @param  {string} data [其他信息]
 * @param  {string} referer [来源]
 * @param  {string} screen_size [屏幕宽高]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function uploadEvent(params) {
  return apiPost('/system/user_event_analysis', params)
}

/**
 * 当前用户进入/退出预发布
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/4349
 *
 * @param  {string} is_prerelease [资源url]
 * @return {[type]}    [description]
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function togglePrerelease(is_prerelease) {
  return apiPut('/system/toggle_prerelease', {is_prerelease})
}

/**
 * 获取来源二维码接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/4757
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function getSourceQRCode(source) {
  return apiGet('/system/mp_source_qrcode', {source})
}


/**
 * 标记新功能角标已读接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/4981
 *
 * @return Promise
 * 
 * @author Pandex
 */
 export function setFeatureBadgeRead(feature_name) {
  return apiPost('/system/feature_badge/read', {feature_name})
}

/**
 * 获取新AA公众号二维码接口
 *
 * @link http://yapi.acagrid.com/project/29/interface/api/5029
 *
 * @return Promise
 * 
 * @author Pandex
 */
export function getNewMPQRCode(scene) {
  return apiGet('/system/new_mp_subscribe_qrcode', {scene})
}

/**
* 获取二维码接口
*
* @author Pandex
*/
export function getMPQrcode(param) {
  return apiGet('/system/mp_qrcode', {param})
}



// WEBPACK FOOTER //
// ./src/api/system.js